import * as React from "react";

;
export const AccountLimits = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M22.25 24h1.5V0h-1.5v24zM12.75 7.2V24h-1.5V7.2h1.5zM1.75 12v12H.25V12h1.5z" fill="#100722" /></svg>;